<template>
  <div class="content d-flex justify-content-center align-items-center">
    <div class="card mb-0">
      <div class="card-body login">
        <div class="text-center mb-3">
          <i class="icon-user-lock icon-2x text-main border-2 border-main rounded-round p-3 mb-3"></i>
          <h2 class="text-title">Ingreso al sistema</h2>
          <span class="d-block text-muted mb-0">Diligencie sus datos de acceso:</span>
        </div>

        <div class="form-group form-group-feedback form-group-feedback-left mb-2">
          <input
            type="text"
            class="form-control"
            placeholder="Nombre de usuario"
            id="email"
            name="email"
            email="true"
            autocomplete="off"
          />
          <div class="form-control-feedback">
            <i class="icon-user text-main"></i>
          </div>
        </div>

        <div class="form-group form-group-feedback form-group-feedback-left">
          <input
            type="password"
            class="form-control"
            placeholder="Contraseña"
            id="pwd"
            name="pwd"
            autocomplete="off"
          />
          <div class="form-control-feedback">
            <i class="icon-lock2 text-main"></i>
          </div>
        </div>

        <div class="form-group mt-4 mb-0">
          <a class="btn bg-main btn-primary btn-block legitRipple">
            INGRESAR
            <i class="icon-circle-right2 ml-2"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ingreso",
  components: {},
  methods: {
    login: function() {
      return this.items.slice(0, top);
    }
  }
};
</script>